import { Logo } from "../components/Logo";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen bg-[#EEF1ED] grid lg:grid-cols-2">
      <div className="flex flex-col px-5 sm:px-10 py-8">
        <Logo />
        <div className="flex-1 flex items-center">
          <div className="w-full max-w-md mx-auto py-10 fade-up">
            <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight">{title}</h1>
            <p className="mt-2 text-[#4B5A54]">{subtitle}</p>
            <div className="mt-8">{children}</div>
            <div className="mt-6 text-sm text-[#4B5A54]">{footer}</div>
          </div>
        </div>
      </div>
      <div className="hidden lg:block p-4">
        <div className="h-full rounded-[2rem] bg-[#1A2B25] relative overflow-hidden p-12 flex flex-col justify-end text-white">
          <img src="https://images.unsplash.com/photo-1543107076-8f86ee268706?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" alt="Misty evergreen forest" className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#1A2B25] via-[#1A2B25]/40 to-transparent" />
          <p className="relative font-display text-4xl font-extrabold leading-tight max-w-md">"We caught a cleanliness issue on day two and fixed it before it hit Google."</p>
          <p className="relative mt-4 text-white/80">— Owner, neighborhood bakery in Portland, OR</p>
        </div>
      </div>
    </div>
  );
}

export const Field = ({ label, optional, ...props }) => (
  <label className="block">
    <span className="text-sm font-semibold text-[#1A2B25]">{label}{optional && <span className="font-normal text-[#778580]"> (optional)</span>}</span>
    <input {...props} className="input-base mt-1.5" />
  </label>
);
